
/* injects from baggage-loader */
require('./deal-sheet-modal.component.html');

import angular from 'angular';

angular.module('AaApp.Opp').component('dealSheetModal', {
    templateUrl: '/app/components/deal-sheet/modals/deal-sheet-modal.component.html',
    controller: DealSheetModalController,
    bindings: {
        resolve: '<',
        close: '&',
        dismiss: '&'
    }
});

/* @ngInject */
function DealSheetModalController($rootScope, globalIframeService) {
    var $ctrl = this;
    $ctrl.$onInit = $onInit;

    function $onInit() {
        const subscription = globalIframeService.subscribe(messageHandler);
        $ctrl.$onDestroy = () => subscription.unsubscribe();
    }

    // this is called from legacy popup deal sheet not the angular deal sheet.
    function messageHandler({ data }) {
        if (data['DEAL_SHEET_CLOSE']) {
            $ctrl.close();
        }
    }
}
